import * as React from "react";
import { UserDetails } from "../../models/UserDetails";
import { Nav } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { BrowserRouter as Router, Route } from "react-router-dom";
import { AdminApiController } from "../../models/AdminApiController.generated";
import { Profile } from "../../models/Profile";

import { ProfilesPage } from "./profiles/profilesPage";
import { AreasPage } from "./Areas/areasPage";
import { UsersPage } from "./users/UsersPage";

interface State {
  users: UserDetails[];
  userProfile?: Profile;
}

export class AdminContainer extends React.Component<{}, State> {
  url = "/engineering/admin";

  constructor(props: any) {
    super(props);

    this.state = {
      users: []
    };
  }

  componentDidMount() {
    this.getUserProfile();
  }

  getUserProfile = () => {
    AdminApiController.getUserProfile()
      .then(profile => {
        this.setState({
          userProfile: profile
        });
      });
  }

  render() {
    return (
      <div className="container">
        <Router>
          <Nav variant="tabs">
            <Nav.Item>
              <LinkContainer to={`${this.url}/users`}>
                <Nav.Link href={`${this.url}/users`}>Users</Nav.Link>
              </LinkContainer>
            </Nav.Item>
            <Nav.Item>
              <LinkContainer to={`${this.url}/profiles`}>
                <Nav.Link href={`${this.url}/profiles`}>Profiles</Nav.Link>
              </LinkContainer>
            </Nav.Item>
            <Nav.Item>
              <LinkContainer to={`${this.url}/areas`}>
                <Nav.Link href={`${this.url}/areas`}>Areas</Nav.Link>
              </LinkContainer>
            </Nav.Item>
          </Nav>
          <Route path={`${this.url}/users`}>
            <UsersPage
              userProfile={this.state.userProfile}
              getUserProfile={this.getUserProfile}
            />
          </Route>
          <Route path={`${this.url}/profiles`}>
            <ProfilesPage
              userProfile={this.state.userProfile}
              getUserProfile={this.getUserProfile}
            />
          </Route>
          <Route path={`${this.url}/areas`}>
            {this.state.userProfile && <AreasPage
                userProfile={this.state.userProfile}
            /> }
          </Route>
        </Router>
      </div>
    );
  }
}
